import * as React from 'react';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

// Sample data
const data = [
  { label: "Akhils", value: "66ac656d4af8eae9d95a257c" },
  { label: "RRR 3", value: "66ac64114af8eae9d95a2563" },
  { label: "Child MEditrina", value: "66a8dcf1c51dea8020f7ac32" },
  { label: "Pinkis", value: "66a8d1d4c51dea8020f7abd0" },
  { label: "bb", value: "66a8ba34539cb4fd2dcdb9f5" },
  { label: "clinic for test 2", value: "66a7241320e0d0e54c926cb6" },
  { label: "Shubham", value: "66a2391767406ee4496c3855" },
  { label: "piyush sir", value: "66a21847749776ea6dbfc755" },
  { label: "deepti", value: "66a2128f749776ea6dbfc6fc" },
  { label: "Priya", value: "66a21173749776ea6dbfc6eb" }
];

function not(a, b) {
  return a.filter((value) => b.findIndex(item => item.value === value.value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.findIndex(item => item.value === value.value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

function TransferList({clinicList, getSelectedClinicToAssign,selectedClinics}) {
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState(clinicList);
  const [right, setRight] = React.useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.findIndex(item => item.value === value.value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  React.useEffect(() => {
    const selectedClinicsList = clinicList.filter(clinic => selectedClinics.includes(clinic.value));
    const unselectedClinics = clinicList.filter(clinic => !selectedClinics.includes(clinic.value));
    setRight(selectedClinicsList);
    setLeft(unselectedClinics);
  }, [clinicList, selectedClinics]);
    const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    const updatedRight = union(right, leftChecked);
    const updatedLeft = not(left, leftChecked);
    setChecked(not(checked, leftChecked));
    getSelectedClinicToAssign(updatedRight);
  };

  const handleCheckedLeft = () => {
    const updatedLeft = union(left, rightChecked);
    const updatedRight = not(right, rightChecked);
    setChecked(not(checked, rightChecked));
    getSelectedClinicToAssign(updatedRight);
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={
              numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected'
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />
      <Divider />
      <List
        sx={{
          width: 300,
          height: 230,
          bgcolor: 'background.paper',
          overflow: 'scroll'
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value.value}-label`;

          return (
            <ListItemButton
              key={value.value}
              role="listitem"
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.findIndex(item => item.value === value.value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.label} />
            </ListItemButton>
          );
        })}
      </List>
    </Card>
  );

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item>{customList('All Branches', left)}</Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>{customList('Branches Accessible', right)}</Grid>
    </Grid>
  );
}

export default TransferList;
